export const ALllStarlineCharts =[
        {
            "resultDate": "12/30/2024",
            "results": [
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "12/31/2024",
            "results": [
                {
                    "winningDigit": "388",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "566",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "250",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "359",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "01/01/2025",
            "results": [
                {
                    "winningDigit": "348",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "668",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "900",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "379",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "790",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "01/02/2025",
            "results": [
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "799",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "770",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "239",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "788",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "01/03/2025",
            "results": [
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "350",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "177",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "377",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "570",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "01/04/2025",
            "results": [
                {
                    "winningDigit": "269",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "400",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "367",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "479",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "230",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "790",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "01/05/2025",
            "results": [
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "399",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "560",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "379",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "01/06/2025",
            "results": [
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "335",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "569",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "269",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "366",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "259",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                     }
            ]
        },
        {
            "resultDate": "01/07/2025",
            "results": [
                {
                    "winningDigit": "488",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "136",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "01/08/2025",
            "results": [
                {
                    "winningDigit": "130",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "550",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "499",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "339",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "01/09/2025",
            "results": [
                {
                    "winningDigit": "479",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "360",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "01/10/2025",
            "results": [
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "577",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "790",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "01/11/2025",
            "results": [
                {
                    "winningDigit": "700",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "338",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "136",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "337",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "360",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "367",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "01/12/2025",
            "results": [
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "388",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "770",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "566",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "890",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "01/13/2025",
            "results": [
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "400",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "460",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "570",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "367",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "259",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "01/14/2025",
            "results": [
                {
                    "winningDigit": "350",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "568",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "01/15/2025",
            "results": [
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "000",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "226",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "556",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "239",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "880",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "136",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "279",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "01/16/2025",
            "results": [
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "358",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "890",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "568",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "259",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "01/17/2025",
            "results": [
                {
                    "winningDigit": "224",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "266",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "01/18/2025",
            "results": [
                {
                    "winningDigit": "348",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "558",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "117",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "138",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "01/19/2025",
            "results": [
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "770",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "01/20/2025",
            "results": [
                {
                    "winningDigit": "138",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "298",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "682",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "335",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "557",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "01/21/2025",
            "results": [
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "198",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "498",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "678",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "379",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "460",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "01/22/2025",
            "results": [
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "298",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "172",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "172",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "856",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "889",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "01/23/2025",
            "results": [
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "355",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "499",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "478",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "01/24/2025",
            "results": [
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "230",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "890",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "01/25/2025",
            "results": [
                {
                    "winningDigit": "788",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "688",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "182",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "350",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "560",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "377",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "01/26/2025",
            "results": [
                {
                    "winningDigit": "355",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "477",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "889",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "488",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "01/27/2025",
            "results": [
                {
                    "winningDigit": "266",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "239",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "559",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "369",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "377",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "01/28/2025",
            "results": [
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "258",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "359",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "899",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "116",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "01/29/2025",
            "results": [
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "379",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "668",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "277",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "700",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "359",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "250",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "01/30/2025",
            "results": [
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "999",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "478",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "116",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "440",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "01/31/2025",
            "results": [
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "02/01/2025",
            "results": [
                {
                    "winningDigit": "599",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "889",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/02/2025",
            "results": [
                {
                    "winningDigit": "788",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "111",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "445",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "888",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "455",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "02/03/2025",
            "results": [
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "335",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "399",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "499",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "111",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "02/04/2025",
            "results": [
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "111",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "247",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "02/05/2025",
            "results": [
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "399",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "335",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "560",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "02/06/2025",
            "results": [
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "111",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "888",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "399",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "770",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "02/07/2025",
            "results": [
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "589",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "688",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/08/2025",
            "results": [
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "400",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "770",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "555",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "02/09/2025",
            "results": [
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "688",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "599",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "678",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "02/10/2025",
            "results": [
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "788",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "599",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "02/11/2025",
            "results": [
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "888",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "222",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "600",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "666",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                     }
            ]
        },
        {
            "resultDate": "02/12/2025",
            "results": [
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "779",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "589",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "800",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "388",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "666",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "233",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "02/13/2025",
            "results": [
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "666",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "888",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "480",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/14/2025",
            "results": [
                {
                    "winningDigit": "355",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "999",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/15/2025",
            "results": [
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "999",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "111",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "589",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/16/2025",
            "results": [
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "111",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "000",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/17/2025",
            "results": [
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "589",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "399",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "480",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "348",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "02/18/2025",
            "results": [
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "700",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "02/19/2025",
            "results": [
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "246",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "258",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "233",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "269",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "02/20/2025",
            "results": [
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "000",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/21/2025",
            "results": [
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "678",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "499",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "337",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "570",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/22/2025",
            "results": [
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "338",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "266",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "02/23/2025",
            "results": [
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "266",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/24/2025",
            "results": [
                {
                    "winningDigit": "480",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "890",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/25/2025",
            "results": [
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "277",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "770",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "02/26/2025",
            "results": [
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "000",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "337",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "02/27/2025",
            "results": [
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "350",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "469",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "02/28/2025",
            "results": [
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "247",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "113",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "790",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "130",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "03/01/2025",
            "results": [
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "000",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "116",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "113",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "468",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "03/02/2025",
            "results": [
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "688",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "000",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "03/03/2025",
            "results": [
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "299",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "277",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "177",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "03/04/2025",
            "results": [
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "116",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "779",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "577",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "03/05/2025",
            "results": [
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "188",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "667",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "199",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "03/06/2025",
            "results": [
                {
                    "winningDigit": "239",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "339",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "359",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "226",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "117",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "469",
                    "winningDigitFamily": 9,
                     }
            ]
        },
        {
            "resultDate": "03/07/2025",
            "results": [
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "369",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "337",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "288",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "269",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                     }
            ]
        },
        {
            "resultDate": "03/08/2025",
            "results": [
                {
                    "winningDigit": "338",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "568",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "900",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "460",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "259",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "558",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "488",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "03/09/2025",
            "results": [
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "337",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "188",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "233",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "477",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "224",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "03/10/2025",
            "results": [
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "177",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "555",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "130",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "333",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "03/11/2025",
            "results": [
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "230",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "358",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "369",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "800",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "03/12/2025",
            "results": [
                {
                    "winningDigit": "777",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "247",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "359",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "113",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "600",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "178",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "779",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "111",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "266",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "03/13/2025",
            "results": [
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "178",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "556",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "03/14/2025",
            "results": [
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "178",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "899",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "000",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "03/15/2025",
            "results": [
                {
                    "winningDigit": "499",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "03/16/2025",
            "results": [
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "589",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "667",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "299",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "03/17/2025",
            "results": [
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "399",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "779",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "03/18/2025",
            "results": [
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "130",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "03/19/2025",
            "results": [
                {
                    "winningDigit": "444",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "599",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "367",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "289",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "03/20/2025",
            "results": [
                {
                    "winningDigit": "339",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "369",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "550",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "277",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "269",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "03/21/2025",
            "results": [
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "388",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "790",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "440",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "03/22/2025",
            "results": [
                {
                    "winningDigit": "225",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "230",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "334",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "188",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "799",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "556",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "03/23/2025",
            "results": [
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "455",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "900",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "03/24/2025",
            "results": [
                {
                    "winningDigit": "230",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "178",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "250",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "258",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "03/25/2025",
            "results": [
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "138",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "889",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "477",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "177",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "03/26/2025",
            "results": [
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "299",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "800",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "113",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "130",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "557",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "03/27/2025",
            "results": [
                {
                    "winningDigit": "277",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "348",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "468",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "226",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "899",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "677",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "568",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "335",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "899",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "03/28/2025",
            "results": [
                {
                    "winningDigit": "360",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "666",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "399",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "244",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "358",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "199",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "246",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "03/29/2025",
            "results": [
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "570",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "999",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "03/30/2025",
            "results": [
                {
                    "winningDigit": "269",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "889",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "03/31/2025",
            "results": [
                {
                    "winningDigit": "136",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "178",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "556",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "04/01/2025",
            "results": [
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "266",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "259",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "377",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "04/02/2025",
            "results": [
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "480",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "550",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "04/03/2025",
            "results": [
                {
                    "winningDigit": "367",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "559",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "339",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "700",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "469",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "455",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "800",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "599",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "04/04/2025",
            "results": [
                {
                    "winningDigit": "279",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "899",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "440",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "04/05/2025",
            "results": [
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "113",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "358",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "244",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "799",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "560",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "04/06/2025",
            "results": [
                {
                    "winningDigit": "269",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "233",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "889",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "335",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "150",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "199",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "246",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "04/07/2025",
            "results": [
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "599",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "557",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "04/08/2025",
            "results": [
                {
                    "winningDigit": "188",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "770",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "358",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "700",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "04/09/2025",
            "results": [
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "367",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "130",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "799",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "04/10/2025",
            "results": [
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "570",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "117",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "377",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "559",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "338",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "04/11/2025",
            "results": [
                {
                    "winningDigit": "116",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "266",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "259",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "289",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "279",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "479",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "04/12/2025",
            "results": [
                {
                    "winningDigit": "337",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "379",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "138",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "558",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "779",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "04/13/2025",
            "results": [
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "334",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "469",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "339",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "700",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "244",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "367",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "445",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                     }
            ]
        },
        {
            "resultDate": "04/14/2025",
            "results": [
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "226",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "350",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "478",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "222",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "460",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "04/15/2025",
            "results": [
                {
                    "winningDigit": "550",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "233",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "178",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "04/16/2025",
            "results": [
                {
                    "winningDigit": "568",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "250",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "355",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "556",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "116",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "04/17/2025",
            "results": [
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "225",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "479",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "589",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "377",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "499",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "04/18/2025",
            "results": [
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "588",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "138",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "348",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "244",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "04/19/2025",
            "results": [
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "358",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "337",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "117",
                    "winningDigitFamily": 9,
                     }
            ]
        },
        {
            "resultDate": "04/20/2025",
            "results": [
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "445",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "279",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "589",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "479",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "04/21/2025",
            "results": [
                {
                    "winningDigit": "247",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "226",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "225",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "468",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "178",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "04/22/2025",
            "results": [
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "259",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "239",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "480",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "04/23/2025",
            "results": [
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "224",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "04/24/2025",
            "results": [
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "226",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "790",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "558",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "04/25/2025",
            "results": [
                {
                    "winningDigit": "250",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "137",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "468",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "460",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "117",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "667",
                    "winningDigitFamily": 9,
                     }
            ]
        },
        {
            "resultDate": "04/26/2025",
            "results": [
                {
                    "winningDigit": "116",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "890",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "04/27/2025",
            "results": [
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "369",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "379",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "335",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "244",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "04/28/2025",
            "results": [
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "334",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "556",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "246",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "279",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "289",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "04/29/2025",
            "results": [
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "479",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "224",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "117",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "337",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "04/30/2025",
            "results": [
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "233",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "338",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "136",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "05/01/2025",
            "results": [
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "339",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "559",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "258",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "05/02/2025",
            "results": [
                {
                    "winningDigit": "113",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "177",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "379",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "779",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "440",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "05/03/2025",
            "results": [
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "138",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "247",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "230",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "569",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "277",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "259",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "05/04/2025",
            "results": [
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "355",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "478",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "468",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "05/05/2025",
            "results": [
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "136",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "150",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "288",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "788",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "379",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "05/06/2025",
            "results": [
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "246",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "338",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "790",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "250",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "279",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "359",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "05/07/2025",
            "results": [
                {
                    "winningDigit": "369",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "469",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "247",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "358",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "677",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "269",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "460",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "05/08/2025",
            "results": [
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "188",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "360",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "350",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "890",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "05/09/2025",
            "results": [
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "348",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "667",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "880",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "568",
                    "winningDigitFamily": 9,
                     }
            ]
        },
        {
            "resultDate": "05/10/2025",
            "results": [
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "178",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "226",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "337",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "560",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "550",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "05/11/2025",
            "results": [
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "130",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "289",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "558",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "557",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "225",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "05/12/2025",
            "results": [
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "899",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "779",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "117",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "445",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "678",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "05/13/2025",
            "results": [
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "599",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "556",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "449",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "480",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "05/14/2025",
            "results": [
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "889",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "479",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "570",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "668",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "05/15/2025",
            "results": [
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "790",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "239",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "230",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "700",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "05/16/2025",
            "results": [
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "500",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "379",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "250",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "460",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "468",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "266",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "05/17/2025",
            "results": [
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "136",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "367",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "589",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "780",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "890",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "388",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "05/18/2025",
            "results": [
                {
                    "winningDigit": "247",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "788",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "359",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "334",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "477",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "05/19/2025",
            "results": [
                {
                    "winningDigit": "259",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "478",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "348",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "566",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "900",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "233",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "05/20/2025",
            "results": [
                {
                    "winningDigit": "455",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "279",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "166",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "289",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "677",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "358",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "05/21/2025",
            "results": [
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "360",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "770",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "350",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "366",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "178",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "05/22/2025",
            "results": [
                {
                    "winningDigit": "568",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "130",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "377",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "690",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "05/23/2025",
            "results": [
                {
                    "winningDigit": "224",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "358",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "246",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "799",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "225",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "458",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "299",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "150",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "277",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "05/24/2025",
            "results": [
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "569",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "369",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "05/25/2025",
            "results": [
                {
                    "winningDigit": "440",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "335",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "889",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "239",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "05/26/2025",
            "results": [
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "480",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "570",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "349",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "258",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "05/27/2025",
            "results": [
                {
                    "winningDigit": "557",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "899",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "469",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "479",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "490",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "880",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "113",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "499",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "05/28/2025",
            "results": [
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "138",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "470",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "270",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "480",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "117",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "05/29/2025",
            "results": [
                {
                    "winningDigit": "359",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "460",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "239",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "566",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "567",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "05/30/2025",
            "results": [
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "233",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "237",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "360",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "240",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "05/31/2025",
            "results": [
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "246",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "377",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "800",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "558",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "06/01/2025",
            "results": [
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "246",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "368",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "700",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "899",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "250",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "06/02/2025",
            "results": [
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "550",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "600",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "800",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "400",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "06/03/2025",
            "results": [
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "400",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "100",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "177",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "116",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "06/04/2025",
            "results": [
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "200",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "377",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "360",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "445",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "06/05/2025",
            "results": [
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "467",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "06/06/2025",
            "results": [
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "457",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "06/07/2025",
            "results": [
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "666",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "300",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "06/08/2025",
            "results": [
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "177",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "06/09/2025",
            "results": [
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "356",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "277",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "278",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "246",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "257",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "06/10/2025",
            "results": [
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "550",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "360",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "177",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "06/11/2025",
            "results": [
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "600",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "256",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "06/12/2025",
            "results": [
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "06/13/2025",
            "results": [
                {
                    "winningDigit": "355",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "06/14/2025",
            "results": [
                {
                    "winningDigit": "557",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "600",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "06/15/2025",
            "results": [
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                     }
            ]
        },
        {
            "resultDate": "06/16/2025",
            "results": [
                {
                    "winningDigit": "566",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "06/17/2025",
            "results": [
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "06/18/2025",
            "results": [
                {
                    "winningDigit": "130",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "177",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "06/19/2025",
            "results": [
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "557",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "06/20/2025",
            "results": [
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "378",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "466",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "06/21/2025",
            "results": [
                {
                    "winningDigit": "550",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "789",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "267",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "900",
                    "winningDigitFamily": 9,
                     }
            ]
        },
        {
            "resultDate": "06/22/2025",
            "results": [
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "456",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "600",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "06/23/2025",
            "results": [
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "330",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "245",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "357",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "448",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "566",
                    "winningDigitFamily": 7,
                     }
            ]
        },
        {
            "resultDate": "06/24/2025",
            "results": [
                {
                    "winningDigit": "778",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "299",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "279",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "150",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "579",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "360",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "06/25/2025",
            "results": [
                {
                    "winningDigit": "344",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "445",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "188",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "350",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "299",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "06/26/2025",
            "results": [
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "150",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "336",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "459",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "367",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "06/27/2025",
            "results": [
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "148",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "990",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "560",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "340",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "370",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "06/28/2025",
            "results": [
                {
                    "winningDigit": "477",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "225",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "380",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "468",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "347",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "578",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "229",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "566",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "480",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "556",
                    "winningDigitFamily": 6,
                     }
            ]
        },
        {
            "resultDate": "06/29/2025",
            "results": [
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "156",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "167",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "244",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "469",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "560",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "230",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "580",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "233",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "446",
                    "winningDigitFamily": 4,
                     }
            ]
        },
        {
            "resultDate": "06/30/2025",
            "results": [
                {
                    "winningDigit": "158",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "348",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "144",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "234",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "670",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "550",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "390",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "669",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "07/01/2025",
            "results": [
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "227",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "268",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "679",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "269",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "558",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "258",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "155",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "689",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "07/02/2025",
            "results": [
                {
                    "winningDigit": "388",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "450",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "146",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "447",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "169",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "255",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "889",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "223",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "189",
                    "winningDigitFamily": 8,
                     }
            ]
        },
        {
            "resultDate": "07/03/2025",
            "results": [
                {
                    "winningDigit": "339",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "345",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "389",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "346",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "179",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "190",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "266",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "366",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "07/04/2025",
            "results": [
                {
                    "winningDigit": "280",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "560",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "589",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "247",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "248",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "236",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "479",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "348",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "138",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                     }
            ]
        },
        {
            "resultDate": "07/05/2025",
            "results": [
                {
                    "winningDigit": "680",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "168",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "145",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "125",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "124",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "290",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "150",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "239",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "157",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "570",
                    "winningDigitFamily": 2,
                     }
            ]
        },
        {
            "resultDate": "07/06/2025",
            "results": [
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "119",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "220",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "556",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "790",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "120",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "126",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "134",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "147",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                     }
            ]
        },
        {
            "resultDate": "07/07/2025",
            "results": [
                {
                    "winningDigit": "235",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "138",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "117",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "238",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "289",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "260",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "122",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "110",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "590",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "139",
                    "winningDigitFamily": 3,
                    },
                {
                    "winningDigit": "127",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "07/08/2025",
            "results": [
                {
                    "winningDigit": "170",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "140",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "135",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "115",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "350",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "159",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "129",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "114",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "149",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "118",
                    "winningDigitFamily": 0,
                    },
                {
                    "winningDigit": "112",
                    "winningDigitFamily": 4,
                    },
                {
                    "winningDigit": "668",
                    "winningDigitFamily": 0,
                     }
            ]
        },
        {
            "resultDate": "07/09/2025",
            "results": [
                {
                    "winningDigit": "116",
                    "winningDigitFamily": 8,
                    },
                {
                    "winningDigit": "128",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "230",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "225",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "160",
                    "winningDigitFamily": 7,
                    },
                {
                    "winningDigit": "123",
                    "winningDigitFamily": 6,
                    },
                {
                    "winningDigit": "339",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "249",
                    "winningDigitFamily": 5,
                    },
                {
                    "winningDigit": "180",
                    "winningDigitFamily": 9,
                    },
                {
                    "winningDigit": "489",
                    "winningDigitFamily": 1,
                    },
                {
                    "winningDigit": "228",
                    "winningDigitFamily": 2,
                    },
                {
                    "winningDigit": "133",
                    "winningDigitFamily": 7,
                     }
            ]
        },
            ]
   